import { fetchCompositeJSON } from '../fetch/fetchCompositeJSON.js';

const WITH_FETCH_COMPOSITE_JSON = 'WITH_FETCH_COMPOSITE_JSON';
function withCtxFetchCompositeJSON() {
  return ctx => {
    // only assign handlers if they have not been already assigned
    if (!ctx.__middleware.WITH_FETCH_COMPOSITE_JSON) {
      Object.assign(ctx, {
        fetchCompositeJSON: {
          __composite: {},
          addFetch: (key, fetcher) => {
            ctx.fetchCompositeJSON.addFetches({
              [key]: fetcher
            });
          },
          addFetches: (fetchers = {}) => {
            Object.assign(ctx.fetchCompositeJSON.__composite, fetchers);
          },
          clearComposite: () => {
            ctx.fetchCompositeJSON.__composite = {};
          },
          fetchComposite: async () => {
            // fetch the composite
            const response = await fetchCompositeJSON(ctx.fetchCompositeJSON.__composite);

            // clear the composite
            ctx.fetchCompositeJSON.clearComposite();

            // return the composite response
            return response;
          },
          getComposite: () => ctx.fetchCompositeJSON.__composite
        }
      });
    }
    ctx.registerMiddleware(WITH_FETCH_COMPOSITE_JSON);
  };
}

export { withCtxFetchCompositeJSON };
